import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { compose, mapProps, withProps, branch, renderNothing } from 'recompose';
import { reduxForm, Field, formValueSelector } from 'redux-form/immutable';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { success } from '../../../app/lib/Actions';
import * as SessionActions from '../../../app/entities/Session/actions';
import requireProps from '../../../app/lib/requireProps';
import * as styles from './styles.css';
import {
  Address,
  DateInput,
  Input,
  PhoneNumberInput,
  SocialSecurityNumberInput,
  validators,
} from '../../../app/components/Form';
import withMe from '../../containers/withMe';
import Routes from '../../Router/Routes';
import Button from '../../../app/components/Button';
import { useTranslation, withTranslation } from 'react-i18next';


const BankName = compose(
  withTranslation(),
  connect((state, { form }) => ({
    newBankAccountNumber: formValueSelector(form)(state, 'bankAccountNumber'),
  })),
  branch(({ initialValues, newBankAccountNumber, t }) => {
    if (initialValues.get('bankAccountNumber') !== newBankAccountNumber) {
      return true;
    }
    return !initialValues.get('bankName');
  },
    renderNothing),
  mapProps(({ initialValues }) => ({
    bankName: initialValues.get('bankName'),
    t: useTranslation().t,
  })),
)((props) => {
  return (
    <p className="help-block">{props.t("Bank")}: {props.bankName}</p>
  )
});
function Me({ isEditable, logout, form, initialValues }) {
  const { t } = useTranslation();

  return (
    <div className="row">
      <div className="col-md-4 col-md-offset-4">
        <h2 className={styles.header}>{t("Mina uppgifter")}</h2>
        <div className={classNames('table-responsive', styles.tableResponsive)}>
          <div className={styles.formTable}>
            <Field
              label={t("Förnamn")}
              name="firstName"
              component={Input}
              isEditable={isEditable}
            />

            <Field
              label={t("Efternamn")}
              name="lastName"
              component={Input}
              isEditable={isEditable}
            />

            <Field
              label={t("Personnummer")}
              name="socialSecurityNumber"
              component={SocialSecurityNumberInput}
              isEditable={false}
              format={SocialSecurityNumberInput.format}
              normalize={SocialSecurityNumberInput.normalize}
              validate={SocialSecurityNumberInput.validate}
            />

            <Field
              label={t("Födelsedatum")}
              name="birthDate"
              component={DateInput}
              type="date"
              isEditable={isEditable}
              validate={[
                validators.date(),
                validators.gtDate('1900-01-01'),
              ]}
            />

            <Field
              label={t("Huvudtelefonnummer")}
              name="phone1"
              component={PhoneNumberInput}
              format={PhoneNumberInput.format}
              normalize={PhoneNumberInput.normalizePhoneNumber}
              isEditable={isEditable}
              validate={validators.phoneNumber()}
            />

            <Field
              label={t("Telefonnummer 2")}
              name="phone2"
              component={PhoneNumberInput}
              format={PhoneNumberInput.format}
              normalize={PhoneNumberInput.normalizePhoneNumber}
              isEditable={isEditable}
              validate={validators.phoneNumber()}
            />

            <Field
              label={t("Telefonnummer 3")}
              name="phone3"
              component={PhoneNumberInput}
              format={PhoneNumberInput.format}
              normalize={PhoneNumberInput.normalizePhoneNumber}
              isEditable={isEditable}
              validate={validators.phoneNumber()}
            />

            <Field
              label={t("Telefonnummer 4")}
              name="phone4"
              component={PhoneNumberInput}
              format={PhoneNumberInput.format}
              normalize={PhoneNumberInput.normalizePhoneNumber}
              isEditable={isEditable}
              validate={validators.phoneNumber()}
            />

            <Field
              label={t("Email, primär")}
              name="primaryEmail"
              component={Input}
              isEditable={isEditable}
              validate={validators.email()}
              normalize={email => email.trim()}
            />

            <Field
              label={t("Email, sekundär")}
              name="secondaryEmail"
              component={Input}
              isEditable={isEditable}
              normalize={email => email.trim()}
            />

            <Field
              label={t("Bankkontonummer")}
              name="bankAccountNumber"
              component={Input}
              isEditable={isEditable}
              validate={validators.numbersSpacesCommasAndDashes()}
            />
            <BankName form={form} initialValues={initialValues} />

            <Address
              isEditable={isEditable}
            />
          </div>
        </div>
        <p>
          {t("För att rätta någon uppgift, vänligen kontakta din konsultchef")}
        </p>
        <p>
          <Button
            onClick={logout}
            testID="logoutBtn"
            stretch
          >
            {t("Logga ut")}
          </Button>
        </p>
      </div>
    </div>
  );
}

Me.defaultProps = {
  isEditable: false,
};

Me.propTypes = {
  isEditable: PropTypes.bool,
  logout: PropTypes.func.isRequired,
  form: PropTypes.string.isRequired,
};

export default compose(
  withMe,
  requireProps(['resource'], true),
  mapProps(({ resource }) => ({
    initialValues: resource,
  })),
  reduxForm({
    form: 'editResource',
  }),
  connect(null,
    dispatch => bindActionCreators({
      deauth: success(SessionActions.DEAUTH),
    }, dispatch),
  ),
  withRouter,
  withProps(({ history, deauth }) => ({
    logout: () => {
      deauth();
      history.push(Routes.login());
    },
  })),
)(Me);
